import React from 'react'
import TopBar from './TopBar'
import SideNav from './SideNav'
import './Layout.css'

export default function Layout({ children }) {
  return (
    <div className="app-shell">
      <TopBar />
      <div className="body">
        <SideNav />
        <main className="content">{children}</main>
      </div>
    </div>
  )
}
